import React from 'react';
import { observer } from 'mobx-react';

import { HomeNavbar } from '../../common/home-navbar';
import { DataForm } from './data-form';
import { SessionStore } from '../../stores/SessionStore';
import { AppRedirect, routeNaming } from '../../routes';
import styles from './ForgotPassword.css';
import { SEO } from '../../common/seo';

const ForgotPassword = observer(() => {
  if (SessionStore.loggedIn) {
    return (
      <AppRedirect routeName={routeNaming.HOME} />
    );
  }
  return (
    <div className={styles.container}>
      <SEO
        title="Recuperar Contraseña"
        description="¿Olvidaste tu contraseña? No te preocupes, puedes restablecerla fácilmente en Carlos Gutiérrez S.A.. Simplemente ingresa tu correo electrónico registrado y recibirás instrucciones para crear una nueva contraseña de forma segura. Recupera el acceso a tu cuenta en segundos y continúa disfrutando de todos nuestros servicios. Si tienes problemas, nuestro equipo de soporte está disponible para ayudarte en todo momento. ¡Recupera tu cuenta ahora y sigue disfrutando de tu experiencia personalizada en Carlos Gutiérrez S.A.!"
        type="website"
      />
      <HomeNavbar />
      <div className={styles.mainContent}>
        <h1 className={styles.title}>Recuperar contraseña</h1>
        <p className={styles.instructions}>
          Ingresa tu dirección de correo electrónico,
          documento o RUT y te enviaremos instrucciones
          para recuperar tu contraseña
        </p>
        <DataForm
          className={styles.form}
        />
      </div>
    </div>
  );
});

export { ForgotPassword };



// WEBPACK FOOTER //
// ./src/pages/forgot-password/ForgotPassword.jsx